// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__erEie","content":"style_content__PD22A","text":"style_text__ZJvG-","button":"style_button__Ydp9A"};